/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Card, Label, Select, WarningIcon } from '@bonitour/components'
import { useMemo, useCallback, useEffect, useRef } from 'react'
import { useServicePickUpAddresses } from 'hooks/domains/useServicePickUpAddresses'
import { formGrid, formItem, highlightLabel, pickUpAddressContainer as container } from './PickUpAddressSection.style'
import { identity } from '@bonitour/common-functions'
import { useFeatureFlag } from 'contexts/Feature'
import { combinedCardStyle, mapCardBackground, noPickupWarning } from 'domains/Booking/Map/BookingMap.styles'
import { useActivity } from 'contexts/Activity'

const DEFAULT_PICKUP_PLACE_INDEX = 0

export const PickUpAddressSection = ({
  onChange = identity,
  onBlur = identity,
  selectedPickUpAddressId,
  serviceId,
  disabled = false,
  bookingMapStyle = false,
  isCombinedExperience = false,
  isBookingShow = false,
  ...other
}) => {
  const isLoaded = useRef(false)

  const handlePickupPlaceChange = useCallback((pickUpPlaceId) => {
    onChange(pickUpPlaceId)
  }, [onChange])

  const {
    activity: {
      pickupOptions
    }
  } = useActivity()

  const { linkedAddresses } = useServicePickUpAddresses({ serviceId })

  const pickUpAddressOptions = useMemo(() => {
    return isCombinedExperience
      ? pickupOptions?.[serviceId]?.map(({ pickupId, label }) => ({
        label: label['pt-br'],
        value: pickupId
      }))
      : linkedAddresses?.map(({ id, name }) => (
        {
          label: name, value: id
        }
      ))
  }, [isCombinedExperience, linkedAddresses, pickupOptions, serviceId])

  const canDisplayNoPickupWarning = useMemo(() => !pickUpAddressOptions?.length, [pickUpAddressOptions])

  const isHidden = useMemo(() => (disabled), [disabled])

  const [isPickupPlacesEnabled, _, isFlagReady] = useFeatureFlag('orb-transport-pickup-selector')

  useEffect(() => {
    if ((!selectedPickUpAddressId && selectedPickUpAddressId) && !canDisplayNoPickupWarning && !isLoaded) {
      isLoaded.current = true
      onChange(
        pickUpAddressOptions[Math.min(DEFAULT_PICKUP_PLACE_INDEX, pickUpAddressOptions.length - 1)].value
      )
    }
  }, [pickUpAddressOptions, onChange, selectedPickUpAddressId, canDisplayNoPickupWarning])

  if (!isFlagReady || !isPickupPlacesEnabled || (isBookingShow && canDisplayNoPickupWarning)) {
    return null
  }

  return (
    <Card padding='20' css={[container, bookingMapStyle && mapCardBackground, isCombinedExperience && combinedCardStyle]} {...other}>
      <div css={[!bookingMapStyle && formGrid]}>
        <div css={[!bookingMapStyle && formItem]}>
          {isCombinedExperience && canDisplayNoPickupWarning
            ? (
              <p css={noPickupWarning}>
                <WarningIcon/>
              Este serviço não possui um local de embarque ativo no momento
              </p>
            )
            : null}
          {(!canDisplayNoPickupWarning)
            ? (
              <>
                <Label htmlFor='pickupPlaceId' css={highlightLabel}>Local de Embarque</Label>
                <Select
                  placeholder={'Selecione Local de Embarque'}
                  onChange={handlePickupPlaceChange}
                  onBlur={onBlur}
                  error={false}
                  disabled={isHidden}
                  value={selectedPickUpAddressId || ''}
                  options={[{ label: 'Nenhum local', value: '' }].concat(pickUpAddressOptions || [])}
                />
              </>
            )
            : null}
        </div>
      </div>

    </Card>
  )
}
